import * as React from 'react';
import {FormattedMessage} from 'react-intl';

import {getQueryAsObject} from 'components/organisms/BuyResidenceGeneral/services/helpers';

import './style.scss';

import {Button, ButtonColor, ButtonSize, ButtonState, ButtonType} from 'components/atoms/LinksAndButtons/Button';
import {SITE_URLS} from 'features/search/constants';
import {useNavigate} from 'react-router';

interface Props {
    objectId: string;
    objectVipKey?: string;
    goToForm?: boolean;
    inactive?: boolean;
}

export const BookingButton: React.FunctionComponent<Props> = ({objectId, objectVipKey, goToForm, inactive}) => {
    const navigate = useNavigate();

    const goToBookingInfo = () => {
        const url = `${SITE_URLS.clickToBuy}info/${objectId}/`;
        navigate({
            pathname: url,
        });
    };

    const goToBookingForm = () => {
        const url = getBuyUrl();
        navigate(url);
    };
    const getBuyUrl = () => {
        let url: string;

        const parameters = getQueryAsObject();
        const bookingId = parameters !== null && Object.prototype.hasOwnProperty.call(parameters, 'bookingId') ? parameters['bookingId'] : null;

        if(typeof objectVipKey === 'undefined' || objectVipKey === null) {
            url = `${SITE_URLS.clickToBuy}${objectId}/`;

            if(bookingId) {
                url += '?bookingId=' + bookingId;
            }

        } else {
            url = `${SITE_URLS.clickToBuy}${objectId}/${objectVipKey}`;
        }

        return url;
    };

    return (
        <Button
            onClick={goToForm 
                ? goToBookingForm 
                : goToBookingInfo}
            buttonState={inactive
                ? ButtonState.INACTIVE
                : ButtonState.DEFAULT
            } 
            buttonColor={ButtonColor.PURCHASE} 
            buttonSize={ButtonSize.DEFAULT} 
            buttonType={ButtonType.DEFAULT} 
        >
            {goToForm ?
                <FormattedMessage id="jm.components.ClickToBuyBanner.bookThis" /> :
                <FormattedMessage id="jm.components.PurchaseSignupBanner.purchaseThis" />
            }
        </Button>
    )
};
